import React from "react";
import { Link } from "react-router-dom";
import bgone from "../../../assets/images/background/bg-16.png";
import bgtwo from "../../../assets/images/background/bg-17.png";
import bgthree from "../../../assets/images/background/bg-18.png";
import menuone from "../../../assets/images/resource/menus-1.jpg";
import menutwo from "../../../assets/images/resource/menus-2.jpg";

function Startermenu() {
    return (
        <>
            <section className="menu-one">
                <div className="right-bg">
                    <img src={bgone} alt="" title="" />
                </div>
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle">
                            <span>ALWAYS FRESH</span>
                        </div>
                        <div className="pattern-image">
                            <img
                                src={
                                    require("../../../assets/images/icons/separator.svg")
                                        .default
                                }
                                alt="mySvgImage"
                            />
                        </div>

                        <h2>Breakfast Sandwich</h2>
                    </div>

                    <div className="row clearfix">
                        <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image">
                                    <img src={menuone} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        MEXICAN WRAP
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                Scrambled eggs, bell peppers,
                                                onions,tomatoes,guacamole,
                                                cilantro, salsa & sour cream.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        SMASHED AVOCADO
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                2 medium poached eggs on an open
                                                face Uprising Egyptian
                                                sourdough, pico de gallo &
                                                arugula.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        ENGLISH MUFFIN SANDWICH
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                A scrambled egg, melted cheddar
                                                cheese, bacon & tomatos.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        HAM & CHEESE CROISSANT
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                * All served with homestyle
                                                potatoes & fresh fruit.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="lower-link-box text-center">
                                    <Link
                                        to="https://swyeat.com/index.html?businessId=69168f8f-827d-4d64-9718-c508cde0fed8&source=webMenu"
                                        className="theme-btn btn-style-two clearfix"
                                    >
                                        <span className="btn-wrap">
                                            <span className="text-one">
                                                view all menu
                                            </span>
                                            <span className="text-two">
                                                view all menu
                                            </span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                <div className="left-bg">
                    <img src={bgtwo} alt="" title="" />
                </div>
                <div className="right-bg-2">
                    <img src={bgthree} alt="" title="" />
                </div>
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle">
                            <span>Delicious</span>
                        </div>

                        <div className="pattern-image">
                            <img
                                src={
                                    require("../../../assets/images/icons/separator.svg")
                                        .default
                                }
                                alt="mySvgImage"
                            />
                        </div>

                        <h2>Famous egg Benedict</h2>
                    </div>

                    <div className="row clearfix">
                        <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image">
                                    <img src={menutwo} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        SWISS CHEESE, HAM &
                                                        ASPARAGUS
                                                    </Link>
                                                </h5>
                                            </div>
                                            <div className="price">
                                                <span></span>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                with 1 or 2 eggs.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        MONTREAL SMOKED MEAT{" "}
                                                        <span className="s-info"></span>
                                                    </Link>
                                                </h5>
                                            </div>
                                            <div className="price">
                                                <span></span>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">with 1 or 2 eggs</Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        SPINACH, FETA CHEESE &
                                                        TOMATO
                                                    </Link>
                                                </h5>
                                            </div>
                                            <div className="price">
                                                <span></span>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                with 1 or 2 eggs.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        SMOKED SALMON
                                                    </Link>
                                                </h5>
                                            </div>
                                            <div className="price">
                                                <span></span>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                with 1 or 2 eggs.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        CANADIAN BACK BACON OR
                                                        STRIP BACON
                                                    </Link>
                                                </h5>
                                            </div>
                                            <div className="price">
                                                <span></span>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                with 1 or 2 eggs.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="lower-link-box text-center">
                                    <Link
                                        to="https://swyeat.com/index.html?businessId=69168f8f-827d-4d64-9718-c508cde0fed8&source=webMenu"
                                        className="theme-btn btn-style-two clearfix"
                                    >
                                        <span className="btn-wrap">
                                            <span className="text-one">
                                                view all menu
                                            </span>
                                            <span className="text-two">
                                                view all menu
                                            </span>
                                        </span>
                                    </Link>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Startermenu;
